import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export enum TaskAssigneeType {
  USER = "user",
  ROLE = "role",
}

export const TaskAssigneeTypeSchema = createEnum(TaskAssigneeType);

export enum TaskAssignmentStatus {
  ACTIVE = "active",
  DISMISSED = "dismissed",
  RESOLVED = "resolved",
}

export const TaskAssignmentStatusSchema = createEnum(TaskAssignmentStatus);

const TaskAssignmentSchema_ = z
  .object({
    id: z.string(),
    taskId: z.string(),
    assigneeType: TaskAssigneeTypeSchema,
    assignedLegacyUserId: z.string().nullable(),
    assignedRole: z.string().nullable(),
    status: TaskAssignmentStatusSchema,
    assignedAt: z.date(),
    resolvedAt: z.date().nullable(),
  })
  .refine(
    (value) =>
      (value.assigneeType === TaskAssigneeType.USER &&
        value.assignedLegacyUserId !== null &&
        value.assignedRole === null) ||
      (value.assigneeType === TaskAssigneeType.ROLE &&
        value.assignedLegacyUserId === null &&
        value.assignedRole !== null),
    {
      message: "Task assignment target does not match assigneeType",
      path: ["assigneeType"],
    },
  );

export const TaskAssignmentSchema: z.ZodType<TaskAssignment> =
  TaskAssignmentSchema_;
export interface TaskAssignment extends z.infer<typeof TaskAssignmentSchema_> {}
